export default __webpack_public_path__ + "static/media/cover11.5bd0ff4d.jpeg";